// ===============================================================
// ✅ App.js — Livora FINAL (LOCKED 100%)
// ✅ NEW: theme.css + gender-based theme bridge
// ===============================================================

import React, { useEffect, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { AccountSessionStateProvider } from "./context/AccountSessionStateContext";
import { ThemeBridgeProvider } from "./context/GenderThemeContext";
import NativeShellController from "./components/NativeShellController";

import "./theme/theme.css";
import ChatDeliveryListener from "./components/ChatDeliveryListener";
import NativeHandoffListener from "./components/NativeHandoffListener";
import AndroidBackButtonHandler from "./components/AndroidBackButtonHandler";
import CallReturnRestorer from "./calls/CallReturnRestorer";
import NativeShellTestButton from "./dev/NativeShellTestButton";
import SnapNativeCameraLabTestButton from "./dev/SnapNativeCameraLabTestButton";
import NativeCallUiTestButton from "./components/NativeCallUiTestButton";
import ZegoNativeRealCameraTestButton from "./dev/ZegoNativeRealCameraTestButton";
import SnapFrameExtractionTestButton from "./dev/SnapFrameExtractionTestButton";
import SnapZegoFilteredCaptureTestButton from "./dev/SnapZegoFilteredCaptureTestButton";
import LoginPage from "./components/LoginPage";
import SelectGenderPage from "./components/SelectGenderPage";
import VerificationPage from "./components/VerificationPage";
import VerificationInfoPage from "./components/VerificationInfoPage";
import RequireGender from "./components/RequireGender";
import HomePage from "./components/HomePage";
import MyProfilePage from "./components/MyProfilePage";
import InvitePage from "./components/InvitePage";
import OnlineUsers from "./components/OnlineUsers";
import UserProfilePage from "./components/UserProfilePage";
import EditProfileForm from "./components/EditProfileForm";
import ChatSettingsPage from "./components/MessagesSettingsPage";
import MyRankRewardsPage from "./components/MyRankRewardsPage";
import FemaleJourneyRewardsPage from "./components/FemaleJourneyRewardsPage";
import PresenceGate from "./components/PresenceGate";
import SingleSessionGate from "./components/SingleSessionGate";
import NotificationsPage from "./components/NotificationsPage";
import BeautyPage from "./beauty/BeautyPage";
import SnapCameraTestPage from "./snap/SnapCameraTestPage";
// Calls
import CallListener from "./calls/CallListener";
import OutgoingCallPage from "./calls/OutgoingCallPage";
import CallRoomPage from "./calls/CallRoomPage";
import NativeCallRoomPage from "./calls/NativeCallRoomPage";
import RouteCrashBoundary from "./components/RouteCrashBoundary";
import AndroidWebCallRoomGuard, {
  NativeRouteBrowserGuard,
} from "./calls/AndroidWebCallRoomGuard";
// MatchRadarPage
import MatchRadarPage from "./pages/MatchRadarPage";
// Wallet / Earnings
import BuyCoinsPage from "./components/Wallet/BuyCoinsPage";
import FemaleEarningsPage from "./components/Wallet/FemaleEarningsPage";
import WithdrawRequestPage from "./components/Earnings/WithdrawRequestPage";
import WithdrawConfirmPage from "./pages/WithdrawConfirmPage/WithdrawConfirmPage";
import WithdrawHistoryPage from "./pages/WithdrawHistoryPage/WithdrawHistoryPage";
import WithdrawHelpPage from "./pages/withdraw/WithdrawHelpPage";
import ConvertEarningsToCoinsPage from "./pages/withdraw/ConvertTokensToCoinsPage";

// Messages
import MessagesPage from "./components/MessagesPage";
import NativeChatRouteBoundary from "./components/NativeChatRouteBoundary";
import FriendsPage from "./components/FriendsPage";

// Levels
import LevelRouter from "./components/LevelRouter";
import ChatPricePage from "./components/FemaleLevelPage/chatPrice/ChatPricePage";

// Settings
import SettingsPage from "./settings/SettingsPage";
import AccountSettings from "./settings/AccountSettings";
import BlockListPage from "./settings/BlockListPage";
import HelpPage from "./settings/HelpPage";
import LanguagePage from "./settings/LanguagePage";
import ChangePhonePage from "./settings/ChangePhonePage";
import ChangeEmailPage from "./settings/ChangeEmailPage";
import ChangePasswordPage from "./settings/ChangePasswordPage";
import DeleteAccountPage from "./settings/DeleteAccountPage";
import PendingDeletePage from "./settings/PendingDeletePage";
import SuspendedAccountPage from "./pages/account/SuspendedAccountPage";

import { SettingsProvider } from "./store/SettingsContext";
import i18n from "./i18n";

// Premium / VPN
import PremiumCenterPage from "./components/PremiumCenterPage";
import VpnSettingsPage from "./settings/VpnSettingsPage";


// SUPPORT
import SupportNewTicketPage from "./support/SupportNewTicketPage";
import SupportHistoryPage from "./support/SupportHistoryPage";
import SupportChatPage from "./support/SupportChatPage";
import PrivacyPage from "./support/PrivacyPage";
import TermsPage from "./support/TermsPage";
import Admin1App from "./admin1/Admin1App";

// ===============================================================
// Routes
// ===============================================================
function AppRoutes() {
  const { user, isReady } = useContext(AuthContext);

  if (!isReady) return null;

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/select-gender" element={<SelectGenderPage />} />
      <Route path="/verification" element={<VerificationPage />} />
      <Route path="/verification-info" element={<VerificationInfoPage />} />
      <Route path="/pending-delete" element={<PendingDeletePage />} />
      <Route path="/account-suspended" element={<SuspendedAccountPage />} />
      <Route path="/admin1/*" element={<Admin1App />} />

      {/* Home */}
      <Route
        path="/home"
        element={
          <RequireGender>
            <HomePage />
          </RequireGender>
        }
      />

      {/* Profile */}
      <Route
        path="/my-profile"
        element={
          <RequireGender>
            <MyProfilePage user={user} />
          </RequireGender>
        }
      />
      <Route
        path="/user/:id"
        element={
          <RequireGender>
            <UserProfilePage />
          </RequireGender>
        }
      />
      <Route
        path="/edit-profile"
        element={
          <RequireGender>
            <EditProfileForm />
          </RequireGender>
        }
      />
<Route
  path="/my-rank-rewards"
  element={
    <RequireGender>
      <MyRankRewardsPage />
    </RequireGender>
  }
/>

<Route
  path="/female-journey-rewards"
  element={
    <RequireGender>
      <FemaleJourneyRewardsPage />
    </RequireGender>
  }
/>

      {/* Social */}
      <Route
        path="/invite"
        element={
          <RequireGender>
            <InvitePage />
          </RequireGender>
        }
      />
      <Route
        path="/online"
        element={
          <RequireGender>
            <OnlineUsers />
          </RequireGender>
        }
      />
       {/* beauty */} 
       <Route
        path="/beauty"
        element={
          <RequireGender>
            <BeautyPage />
          </RequireGender>
        }
      />
      <Route
        path="/snap-camera"
        element={
          <RequireGender>
            <SnapCameraTestPage />
          </RequireGender>
        }
      />
       
      {/* Chat settings */}
      <Route
        path="/chat-settings"
        element={
          <RequireGender>
            <ChatSettingsPage />
          </RequireGender>
        }
      />

      {/* Messages */}
      <Route
        path="/messages"
        element={
          <RequireGender>
            <MessagesPage />
          </RequireGender>
        }
      />

      {/* Notifications */}
      <Route
        path="/notifications"
        element={
          <RequireGender>
            <NotificationsPage />
          </RequireGender>
        }
      />

      {/* Chat */}
      <Route
        path="/chat/:chatId"
        element={
          <RequireGender>
            <NativeChatRouteBoundary />
          </RequireGender>
        }
      />
      <Route
        path="/chat/new/:chatId"
        element={
          <RequireGender>
            <NativeChatRouteBoundary />
          </RequireGender>
        }
      />

      <Route
        path="/friends"
        element={
          <RequireGender>
            <FriendsPage />
          </RequireGender>
        }
      />

      {/* Wallet / Earnings */}
      <Route
        path="/buy-coins"
        element={
          <RequireGender>
            <BuyCoinsPage />
          </RequireGender>
        }
      />
      <Route
        path="/female-earnings"
        element={
          <RequireGender>
            <FemaleEarningsPage />
          </RequireGender>
        }
      />
      <Route
        path="/withdraw-request"
        element={
          <RequireGender>
            <WithdrawRequestPage />
          </RequireGender>
        }
      />
      <Route
        path="/withdraw-confirm/:id"
        element={
          <RequireGender>
            <WithdrawConfirmPage />
          </RequireGender>
        }
      />
      <Route
        path="/withdraw-history"
        element={
          <RequireGender>
            <WithdrawHistoryPage />
          </RequireGender>
        }
      />
      <Route
        path="/convert-earnings-to-coins"
        element={
          <RequireGender>
            <ConvertEarningsToCoinsPage />
          </RequireGender>
        }
      />
      <Route
        path="/withdraw-help"
        element={
          <RequireGender>
            <WithdrawHelpPage />
          </RequireGender>
        }
      />

      {/* CALLS */}
      <Route
        path="/call-outgoing/:callId"
        element={
          <RequireGender>
            <OutgoingCallPage />
          </RequireGender>
        }
      />
      <Route
        path="/call/:callId"
        element={
          <RequireGender>
            <RouteCrashBoundary>
              <AndroidWebCallRoomGuard>
                <CallRoomPage />
              </AndroidWebCallRoomGuard>
            </RouteCrashBoundary>
          </RequireGender>
        }
      />
      <Route
        path="/call-native/:callId"
        element={
          <RequireGender>
            <RouteCrashBoundary>
              <NativeRouteBrowserGuard>
                <NativeCallRoomPage />
              </NativeRouteBrowserGuard>
            </RouteCrashBoundary>
          </RequireGender>
        }
      />
      <Route
        path="/match-radar"
        element={
          <RequireGender>
            <MatchRadarPage />
          </RequireGender>
        }
      />

      {/* Levels */}
      <Route
        path="/my-level"
        element={
          <RequireGender>
            <LevelRouter />
          </RequireGender>
        }
      />
      <Route
        path="/fe/chat-price"
        element={
          <RequireGender>
            <ChatPricePage />
          </RequireGender>
        }
      />

      {/* Premium */}
      <Route
        path="/premium"
        element={
          <RequireGender>
            <PremiumCenterPage />
          </RequireGender>
        }
      />
      <Route
        path="/premium/vpn"
        element={
          <RequireGender>
            <VpnSettingsPage />
          </RequireGender>
        }
      />

      {/* Settings */}
      <Route
        path="/settings"
        element={
          <RequireGender>
            <SettingsPage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/account"
        element={
          <RequireGender>
            <AccountSettings />
          </RequireGender>
        }
      />
      <Route
        path="/settings/blocklist"
        element={
          <RequireGender>
            <BlockListPage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/help"
        element={
          <RequireGender>
            <HelpPage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/language"
        element={
          <RequireGender>
            <LanguagePage />
          </RequireGender>
        }
      />
   
      <Route
        path="/settings/change-phone"
        element={
          <RequireGender>
            <ChangePhonePage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/change-email"
        element={
          <RequireGender>
            <ChangeEmailPage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/change-password"
        element={
          <RequireGender>
            <ChangePasswordPage />
          </RequireGender>
        }
      />
      <Route
        path="/settings/delete-account"
        element={
          <RequireGender>
            <DeleteAccountPage />
          </RequireGender>
        }
      />

      {/* SUPPORT */}
      <Route path="/support/new/:type" element={<SupportNewTicketPage />} />

      <Route
        path="/support/history"
        element={
          <RequireGender>
            <SupportHistoryPage />
          </RequireGender>
        }
      />

      <Route
        path="/support/ticket/:ticketId"
        element={
          <RequireGender>
            <SupportChatPage />
          </RequireGender>
        }
      />

      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
    </Routes>
  );
}

// ===============================================================
// App Root
// ===============================================================
export default function App() {
  useEffect(() => {
    console.log("[bootCheck] App mounted");
  }, []);

  useEffect(() => {
    const RTL_LANGS = ["ar", "fa", "he"];

    const applyDir = (lng) => {
      const isRTL = RTL_LANGS.includes(lng);
      document.documentElement.dir = isRTL ? "rtl" : "ltr";
      document.documentElement.lang = lng;
    };

    applyDir(i18n.language);
    i18n.on("languageChanged", applyDir);

    return () => i18n.off("languageChanged", applyDir);
  }, []);

  return (
    <SettingsProvider>
      <AuthProvider>
        <Router>
          <AccountSessionStateProvider>
          <ThemeBridgeProvider>
            <AndroidBackButtonHandler />
            <CallReturnRestorer />

            <div id="recaptcha-container" style={{ display: "none" }} />

            {/* ✅ شغّال دائمًا (Presence + Calls) */}
            <PresenceGate />
            <SingleSessionGate />
            <CallListener />

            {/* ✅ Delivered listener لازم يكون هون */}
            <ChatDeliveryListener />
            <NativeHandoffListener />
            <NativeShellController />

            {process.env.REACT_APP_NATIVE_SHELL_TEST_BUTTON === "true" && (
              <NativeShellTestButton />
            )}

            {process.env.REACT_APP_SNAP_NATIVE_CAMERA_LAB === "true" && (
              <SnapNativeCameraLabTestButton />
            )}

            {process.env.REACT_APP_NATIVE_CALL_UI_TEST === "true" && (
              <NativeCallUiTestButton />
            )}

            {process.env.REACT_APP_ZEGO_NATIVE_REAL_CAMERA_TEST === "true" && (
              <ZegoNativeRealCameraTestButton />
            )}

            {process.env.REACT_APP_SNAP_FRAME_EXTRACTION_TEST === "true" && (
              <SnapFrameExtractionTestButton />
            )}

            {process.env.REACT_APP_SNAP_ZEGO_FILTERED_CAPTURE_TEST === "true" && (
              <SnapZegoFilteredCaptureTestButton />
            )}

            <AppRoutes />
          </ThemeBridgeProvider>
          </AccountSessionStateProvider>
        </Router>
      </AuthProvider>
    </SettingsProvider>
  );
}